import React, { PropsWithChildren } from 'react';

type Props = {
  message: string;
  className?: string;
} & PropsWithChildren;

export default function EmptyPage({
  message,
  children,
  className = '',
}: Props) {
  return (
    <div
      className={`${className} p-4 text-center flex flex-col gap-1 item-enter justify-center w-full min-h-fit bg-gray-50 text-gray-400 font-medium rounded-lg`}
    >
      <h5>{message}</h5>
      {children && <>{children}</>}
    </div>
  );
}
